import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { firestore } from '../services/firebase';
import {
  isCleroPlusEnabled,
  WEB_PAYMENTS_CONFIG_COLLECTION,
  WEB_PAYMENTS_CONFIG_DOCUMENT,
} from '../services/webPaymentsFeatureFlag';

export const useCleroPlusEnabled = (): boolean => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => onSnapshot(
    doc(firestore, WEB_PAYMENTS_CONFIG_COLLECTION, WEB_PAYMENTS_CONFIG_DOCUMENT),
    (snapshot) => setEnabled(snapshot.exists() && isCleroPlusEnabled(snapshot.data())),
    (error) => {
      console.error('Failed to load appConfig/feature_flags.cleroPlusEnabled:', error);
      setEnabled(false);
    },
  ), []);

  return enabled;
};
